import { render, staticRenderFns } from "./UserSettings_PasswordEdit.vue?vue&type=template&id=1e2afc53&"
import script from "./UserSettings_PasswordEdit.vue?vue&type=script&lang=js&"
export * from "./UserSettings_PasswordEdit.vue?vue&type=script&lang=js&"
import style0 from "./UserSettings_PasswordEdit.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports